import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AppConstants from "@src/utils/app.constants";
import { DepartmentTaskRef, OverviewStore, TaskOverviewModelRef } from "../domain/overview.model";
import convertToForm from "@src/utils/payload-to-form-converter";
import { ApplicationResponse } from "@src/common/domain/common.model";
import api from "@src/common/services/api.service";
import { ProjectType } from "@src/utils/data-global";

// export const fetchOverviewList = createAsyncThunk<any[], void>(
//   "overview/fetchoverview",
//   async () => {
//     return [
//       {
//         totalNumberOfTask: 15,
//         taskAssigned: 5,
//         taskInProgress: 5,
//         taskCompleted: 3,
//         taskDelayed: 2,
//       },
//     ];
//   }
// );

export const fetchOverviewChartData = createAsyncThunk<any,{projectId: string,projectType: string} 
>("overview/fetchOverviewChartData", async ({projectId,projectType}) => {
  const url = `${AppConstants.api}/project/dashboard-task-count`;
  const response = await api.get<ApplicationResponse<any>>(
    url, {
      params: {
          projectId,
          projectType
        },
    }
  );
  return response.data.data || {};
});

export const fetchDepartmentTaskChartData = createAsyncThunk<DepartmentTaskRef[],{projectId: string,projectType:string} 
>("overview/fetchDepartmentTaskChartData", async ({projectId,projectType}) => {
  const url = `${AppConstants.api}/task/list-by-department`;
  const response = await api.get<ApplicationResponse<DepartmentTaskRef[]>>(
    url, {
      params: {
          id: projectId,
          type:projectType
        },
    }
  );
  return response.data.data || [];
});

const OverviewSlice = createSlice({
  name: "overview",
  initialState: {
    minimal: { status: "loading", error: null, data: [] },
    departmentTaskMinimal: { status: "loading", error: null, data: [] },
    taskOverviewMinimal: { status: "loading", error: null, data: {} }
  } as OverviewStore,
  reducers: {
    updateOverviewList: (state, action) => {
      state.minimal.data.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOverviewChartData.pending, (state, action) => {
        state.taskOverviewMinimal = {
          status: "loading",
          data: {},
          error: null,
        };
      })
      .addCase(fetchOverviewChartData.fulfilled, (state, action) => {
        state.taskOverviewMinimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchOverviewChartData.rejected, (state, action) => {
        state.taskOverviewMinimal = {
          status: "failed",
          data: {},
          error: action.error,
        };
      })
      .addCase(fetchDepartmentTaskChartData.pending, (state, action) => {
        state.departmentTaskMinimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchDepartmentTaskChartData.fulfilled, (state, action) => {
        state.departmentTaskMinimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchDepartmentTaskChartData.rejected, (state, action) => {
        state.departmentTaskMinimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      });
  },
});
export const { updateOverviewList } = OverviewSlice.actions;

export default OverviewSlice.reducer;
